import {
    GET_SPORT_TYPES_REQUEST,
    GET_SPORT_TYPES_SUCCESS,
    RESET_SPORT_TYPES,
} from '../actions/types';

const initialState = {
    fetching: false,
    sportsList: [],
};

const sportTypesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SPORT_TYPES_REQUEST:
            return { ...state, fetching: true };
        case GET_SPORT_TYPES_SUCCESS:
            const newSportsList = action.payload.length ? action.payload : state.sportsList;
            return { ...state, fetching: false, sportsList: newSportsList };
        case RESET_SPORT_TYPES: {
            return { ...state, sportsList: [] };
        }
        default:
            return state;
    }
};

export default sportTypesReducer;
